import { Component } from 'react';
import PropTypes from 'prop-types';

import { createColorStyles } from '../common/utilities';

export class JobItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            allowsUp: false,
            allowsDown: false,
        }
    }

    componentDidMount() {
        const { jobs, job, levelIndex, levels } = this.props;
        const id = job.id;

        const maxLevelIndex = levels.length - 1;

        const jobsGrowthLateral = !!(job.job_growth_opportunities && job.job_growth_opportunities.length);

        const jobsDown = jobs
            .filter(jobItem => jobItem.job_growth_opportunities && jobItem.job_growth_opportunities.includes(job.id))
            .map(jobItem => jobItem.id)
            .length

        this.setState({
            // Top most level jobs should only point down (if you hover on the top half of the node nothing is displayed). Lateral job opps will be part of the down click.
            allowsUp: jobsGrowthLateral,
            allowsDown: jobsDown,
        })
    }

    render() {
        const { job, levelIndex, cat, catIndex, categories, levels, position, isShowCollegeDegree, isShowSalary } = this.props;
        const { allowsUp, allowsDown } = this.state;

        const classes = `level-${levelIndex + 1}${levelIndex + 1 === levels.length ? ' level-last' : ''}${levelIndex + 1 === 1 ? ' level-first' : ''} cat-${catIndex + 1}${catIndex + 1 === categories.length ? ' cat-last' : ''}`;

        return (
            <div
                className={`job position-${position} ${classes}`}
                data-id={job.id}
                style={createColorStyles(cat)}
                data-level-index={levelIndex}
            >
                <div className="front">
                    <div className="dot">
                        { job.is_union_job && <div className="special union" />}
                        { isShowCollegeDegree && job.requires_college_degree && !job.is_union_job && <div className="special diamond" />}

                        <div className="arrows">
                            {
                                allowsUp ? (
                                    <div
                                        className="direction growth"
                                        data-direction="growth-lateral"
                                    >
                                        <div className="arrow central" />
                                        <div className="arrow aside left" />
                                        <div className="arrow aside right" />
                                    </div>
                                ) : null
                            }

                            {
                                allowsDown ? (
                                    <div
                                        className="direction down"
                                        data-direction="down"
                                    >
                                        <div className="arrow central" />
                                        <div className="arrow aside left" />
                                        <div className="arrow aside right" />
                                    </div>
                                ) : null
                            }

                            <div className="direction middle" data-direction="middle" />
                        </div>
                    </div>
                    <div className="title">{job.name}</div>
                </div>

                <div className="description">
                    <div className="description-inner">
                        <button className="description-close"><span className="show-for-sr">Close</span></button>
                        <div className="description-title">{job.name}</div>
                        {
                            isShowCollegeDegree && job.requires_college_degree
                                ? <div className="special diamond"><span>College Degree Required</span></div>
                                : null
                        }

                        {
                            isShowSalary && job.compensation.salary.low_end && job.compensation.salary.high_end ? (
                                <div className="price annual">{job.compensation.salary.low_end} - {job.compensation.salary.high_end} / year</div>
                            ) : null
                        }

                        {
                            isShowSalary && job.compensation.hourly.low_end && job.compensation.hourly.high_end ? (
                                <div className="price hour">{job.compensation.hourly.low_end} - {job.compensation.hourly.high_end} / hour</div>
                            ) : null
                        }

                        <a href={`#modal-${job.id}`} className="button js-modal">Details</a>
                    </div>
                </div>

            </div>
        );
    }
}

JobItem.propTypes = {
    job: PropTypes.object.isRequired,
    isShowCollegeDegree: PropTypes.bool.isRequired,
    position: PropTypes.number.isRequired,
    cat: PropTypes.object.isRequired,
    categories: PropTypes.array.isRequired,
    levels: PropTypes.array.isRequired,
    levelIndex: PropTypes.number.isRequired,
    catIndex: PropTypes.number.isRequired,
}
